// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__c_v25","empty":"ModalGraph_empty__3mDG9"};